// Libraries
import React from 'react'
import styled from 'styled-components'
import { motion } from 'framer-motion'

export const UpperArrow = styled(motion.img)`
  margin: 0 auto;
  width: 25px;
  height: 10px;
`;

export const LowerArrow = styled(motion.img)`
  margin: 0 auto;
  width: 25px;
  height: 10px;
`;